<template>
  <div>
    <GModal class="modal--upload-photo normalize-gutter">
      <div slot="header">
        <div class="show-desktop">
          <button type="button" class="close" aria-label="Close">
            <img src="/assets/img/icons/close-modal.svg" alt="SOCO" @click.prevent="closeModal" />
          </button>

          <h2 class="modal-heading">Upload Photo</h2>
        </div>

        <div class="show-mobile">
          <button type="button" class="close" aria-label="Close">
            <img src="/assets/img/icons/back.svg" alt="SOCO" @click.prevent="closeModalMobile" />
          </button>

          <h2 class="modal-heading modal-heading__header">Add Photo</h2>
        </div>
      </div>

      <div slot="body" ref="modalBodyUploadPhoto" class="modal-body-content">
        <div class="bj-uploader" :class="{ dragover: isDragover }">
          <form
            v-show="temporaryProductShot.length === 0"
            ref="bjUploader"
            method="post"
            action=""
            enctype="multipart/form-data"
            class="bj-uploader__single"
          >
            <p class="bj-uploader__heading hidden-mobile">Drag and drop photos at any time</p>
            <p class="bj-uploader__text-stripper hidden-mobile">
              - - - - - - - - - - - - - - - &nbsp;or&nbsp; - - - - - - - - - - - - - - -
            </p>
            <div class="bj-uploader__input-file">
              <input
                type="file"
                class=""
                accept="image/png, image/jpeg, image/jpg"
                multiple
                @change="onProcessFile($event)"
              />
              <span class="bj-uploader__text-input">Browse File</span>
            </div>
          </form>
          <template v-if="screen.isDesktop">
            <div v-show="temporaryProductShot.length > 0" class="bj-uploader__multiple">
              <div v-for="(item, key) in temporaryProductShot" :key="key" class="bj-uploader-frame">
                <div class="bj-uploader-frame__content">
                  <button type="button" class="close" aria-label="Close">
                    <img
                      src="/assets/img/icons/close-modal.svg"
                      alt="SOCO"
                      @click.prevent="removeTemporaryProduct(key)"
                    />
                  </button>
                  <div class="bj-uploader-frame__thumb">
                    <img :src="item.file" class="bj-uploader-frame__img" alt="SOCO" />
                    <a href="" class="bj-uploader-frame__icon-crop" @click.prevent="cropImage(item.file, key)"></a>
                  </div>

                  <div class="bj-uploader-frame__caption">
                    <label class="bj-uploader-frame__heading">Photo Caption</label>
                    <span class="bj-uploader-frame__counter-caption">{{ item.caption.length }} / 100</span>

                    <textarea
                      :value="item.caption"
                      class="form-control bj-uploader-frame__textare"
                      placeholder="Write your caption here..."
                      maxlength="100"
                      @input="updateProductShotCaption($event, key)"
                    ></textarea>
                  </div>
                </div>
              </div>

              <form
                v-if="productShot.length + temporaryProductShot.length < 6"
                ref="bjUploaderSmall"
                method="post"
                action=""
                enctype="multipart/form-data"
                class="bj-uploader-small"
              >
                <p v-if="isSupport" class="bj-uploader-small__text">Drag and drop photos at any time</p>
                <!-- <div class="bj-uploader-small__input-file">
						<input type="file" name="" @change="onProcessFile($event)" class="">
						<label class="bj-uploader-small__placeholder"><span class="lighter">or</span> CHOOSE FILE</label>
					</div> -->
              </form>
            </div>
          </template>
          <template v-else>
            <div v-show="temporaryProductShot.length > 0" class="bj-uploader__multiple">
              <div v-for="(item, key) in temporaryProductShot" :key="key" class="bj-uploader-frame">
                <div class="bj-uploader-frame__content">
                  <div class="bj-uploader-frame__thumb">
                    <img :src="item.file" class="bj-uploader-frame__img" alt="SOCO" />
                    <a href="" class="bj-uploader-frame__icon-crop" @click.prevent="cropImage(item.file, key)"></a>
                  </div>

                  <div class="bj-uploader-frame__caption">
                    <label class="bj-uploader-frame__heading">Say something about your photo</label>
                    <span class="bj-uploader-frame__counter-caption">{{ item.caption.length }} / 100</span>

                    <textarea
                      :value="item.caption"
                      class="form-control bj-uploader-frame__textare"
                      placeholder="Write your caption here..."
                      maxlength="100"
                      @input="updateProductShotCaption($event, key)"
                    ></textarea>
                  </div>
                </div>
              </div>

              <form
                v-if="productShot.length + temporaryProductShot.length < 6"
                ref="bjUploaderSmall"
                method="post"
                action=""
                enctype="multipart/form-data"
                class="bj-uploader-small"
              >
                <input
                  type="file"
                  name=""
                  class=""
                  accept="image/png, image/jpeg, image/jpg"
                  multiple
                  @change="onProcessFile($event)"
                />
                <img src="/assets/img/upload-more.svg" width="298" class="" alt="SOCO" />
                <!-- <p class="bj-uploader-small__text" v-if="isSupport">Drag and drop photos at any time</p> -->
                <!-- <div class="bj-uploader-small__input-file">
						<input type="file" name="" @change="onProcessFile($event)" class="">
						<label class="bj-uploader-small__placeholder"><span class="lighter">or</span> CHOOSE FILE</label>
					</div> -->
              </form>
            </div>
          </template>
          <p v-if="errorUploadPhoto" class="text-error text-center">{{ messageErrorUploadPhoto }}</p>
        </div>
      </div>
      <div slot="footer">
        <template v-if="screen.isDesktop">
          <div v-show="temporaryProductShot.length" class="btn-row text-right">
            <div class="btn-col">
              <div class="btn-add-photo">
                <input
                  v-if="productShot.length < 6 && temporaryProductShot.length < 6"
                  type="file"
                  name=""
                  class=""
                  accept="image/png, image/jpeg, image/jpg"
                  multiple
                  @change="onProcessFile($event)"
                />
                <button
                  type="button"
                  class="btn btn-minimal btn-more-photo"
                  :class="{ disabled: !(productShot.length < 6 && temporaryProductShot.length < 6) }"
                >
                  Add more
                </button>
              </div>
            </div>
            <div class="btn-col">
              <button v-if="processUpload" type="button" class="btn btn-dark btn-upload">Processing..</button>
              <button v-else type="button" class="btn btn-dark btn-upload" @click.prevent="uploadImage">Upload</button>
            </div>
          </div>
        </template>
        <template v-else>
          <div v-show="temporaryProductShot.length" class="btn-row text-right">
            <div class="btn-col w-100">
              <button v-if="processUpload" type="button" class="btn btn-dark btn-upload">Processing..</button>
              <button v-else type="button" class="btn btn-dark btn-upload" @click.prevent="uploadImage">
                Add photo
              </button>
            </div>
          </div>
        </template>
      </div>
    </GModal>
    <ModalConfirmationDiscardPhoto v-if="showModalConfirmationDiscardPhoto" />
  </div>
</template>

<script>
import Q from 'q';
import Compressor from 'compressorjs';
import ModalConfirmationDiscardPhoto from '@/components/global/modal/modal-confirmation-discard-photo';

export default {
  name: 'modal-upload-photo',
  components: {
    ModalConfirmationDiscardPhoto,
  },
  data() {
    return {
      errorUploadPhoto: false,
      isFileChoose: false,
      fileSizeExceed: false,
      isDragover: false,
      isSupport: false,
      messageErrorUploadPhoto: '',
      processUpload: false,
    };
  },
  computed: {
    productShot() {
      return this.$store.state.writeReview.productShot;
    },
    screen() {
      return this.$store.state.screen;
    },
    temporaryProductShot() {
      return this.$store.state.writeReview.temporaryProductShot;
    },
    showModalConfirmationDiscardPhoto() {
      return this.$store.state.modal.isModalShow.confirmationDiscardPhoto;
    },
  },
  mounted() {
    if (this.isBrowserSupport()) {
      this.setupDragNDrop();
    }

    if (this.screen.width < 741) {
      this.buildStyle();
    }
  },
  methods: {
    removeTemporaryProduct(key) {
      this.$store.dispatch('removeTemporaryProductShot', key);
    },
    removeAllTemporaryProduct() {
      this.$store.dispatch('removeAllTemporaryProductShot');
    },
    addEventsListener(elTarget, eventStr, cb) {
      const arrEvent = eventStr.trim().split(' ');

      if (this.$SO.type(elTarget) === 'object') {
        if (arrEvent.length > 1) {
          for (let i = 0; i < arrEvent.length; i++) {
            elTarget.addEventListener(arrEvent[i], cb);
          }
        } else {
          elTarget.addEventListener(eventStr, cb);
        }
      }

      if (this.$SO.type(elTarget) === 'array') {
        for (let i = 0; i < elTarget.length; i++) {
          if (arrEvent.length > 1) {
            for (let j = 0; j < arrEvent.length; j++) {
              elTarget[i].addEventListener(arrEvent[j], cb);
            }
          } else {
            elTarget[i].addEventListener(eventStr, cb);
          }
        }
      }
    },
    buildStyle() {
      const windowHeight = window.innerHeight;
      const modalFooterHeight = 56;
      const modalHeaderHeight = 55;
      const maxContentHeight = windowHeight - (modalFooterHeight + modalHeaderHeight);

      this.$refs.modalBodyUploadPhoto.style.maxHeight = maxContentHeight + 'px';
      this.$refs.modalBodyUploadPhoto.style.minHeight = maxContentHeight + 'px';
    },
    closeModal() {
      this.$store.dispatch('setModalUploadPhoto', false);
    },
    closeModalMobile() {
      this.$store.commit('toggleModalGlobalState', { modalName: 'confirmationDiscardPhoto' });
    },
    cropImage(fileImageBase64, productShotKey) {
      this.$store.dispatch('setImageForCrop', {
        file: fileImageBase64,
        productShotKey: productShotKey,
      });
      this.$store.dispatch('setModalCropPhoto', true);
    },
    dataURItoBlob(dataURI) {
      const arr = dataURI.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const byteString = atob(dataURI.split(',')[1]);
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ab], { type: mime });
    },
    fileToBase64(file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        this.$store.dispatch('addDataTemporaryProductShot', reader.result);
      }.bind(this);
      reader.onerror = function (error) {
        console.log(error);
      };
    },
    isBrowserSupport() {
      const div = document.createElement('div');
      const isSupport =
        ('draggable' in div || ('ondragstart' in div && 'ondrop' in div)) &&
        'FormData' in window &&
        'FileReader' in window;
      this.isSupport = isSupport;
      return isSupport;
    },
    onProcessFile(e) {
      const files = e.target.files;
      for (let i = 0; i < files.length; i++) {
        this.validationFile(files[i], files.length);
      }
    },
    setupDragNDrop() {
      const uploader = this.$refs.bjUploader;
      const uploaderSmall = this.$refs.bjUploaderSmall;

      this.addEventsListener([uploader, uploaderSmall], 'dragover dragenter', (e) => {
        e.preventDefault();
        this.isDragover = true;
      });

      this.addEventsListener([uploader, uploaderSmall], 'dragleave dragend', (e) => {
        e.preventDefault();
        this.isDragover = false;
      });

      this.addEventsListener([uploader, uploaderSmall], 'drop', (e) => {
        e.preventDefault();
        this.isDragover = false;

        if (e.dataTransfer.items) {
          // Use DataTransferItemList interface to access the file(s)
          for (let i = 0; i < e.dataTransfer.items.length; i++) {
            // If dropped items aren't files, reject them
            if (e.dataTransfer.items[i].kind === 'file') {
              const file = e.dataTransfer.items[i].getAsFile();

              this.validationFile(file);
            }
          }
        } else {
          // Use DataTransfer interface to access the file(s)
          for (let i = 0; i < e.dataTransfer.files.length; i++) {
            const file = e.dataTransfer.files[i].name;

            this.validationFile(file);
          }
        }
      });
    },
    updateProductShotCaption(e, productShotKey) {
      this.$store.commit('updateTemporaryProductShotCaption', {
        productShotKey: productShotKey,
        newCaption: e.target.value,
      });
    },
    uploadImage() {
      const resProductShot = [];
      if (this.$SO.size(this.temporaryProductShot)) {
        this.processUpload = true;
        return Q.try(() => {
          const promises = [];
          this.$SO.each(this.temporaryProductShot, (key, objProduct) => {
            if (objProduct.file) {
              const filename = Math.floor(100000000000 * Math.random());
              const fileBlob = this.dataURItoBlob(objProduct.file);

              promises.push(
                this.$MS_SOCO_PUBLIC_API_URL(`pre-signed-url`, {
                  params: {
                    fileName: `${filename}.${fileBlob.type.replace('image/', '')}`,
                    contentType: fileBlob.type,
                  },
                }).then((response) => {
                  delete axios.defaults.withCredentials;
                  resProductShot.push({
                    fileImageBase64: response.data.data.url,
                    caption: objProduct.caption,
                  });
                  return axios.put(response.data.data.signedUrl, fileBlob, {
                    headers: { 'Content-Type': fileBlob.type },
                  });
                })
              );
            }
          });
          return Q.all(promises);
        })
          .then(() => {
            for (let i = 0; i < resProductShot.length; i++) {
              this.$store.dispatch('addDataProductShot', resProductShot[i]);
            }
            this.$store.commit('resetDataTemporaryProductShot');
            this.$store.dispatch('setModalUploadPhoto', false);
          })
          .catch((error) => {
            console.log(error);
            this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
          })
          .finally(() => {
            axios.defaults.withCredentials = true;
            this.processUpload = false;
          });
      }
    },
    validationFile(file, totalFiles = 1) {
      const totalMaxFile = 6;
      const isReachTotalMaxFile =
        this.productShot.length + totalFiles + this.temporaryProductShot.length > totalMaxFile;

      if (file) {
        if (file.size < 5242880 && /png|jpg|jpeg/.test(file.type) && !isReachTotalMaxFile) {
          const self = this;
          new Compressor(file, {
            height: 600,
            width: 600,
            mimeType: 'image/png',
            quality: 0.8,
            success(fileAfterCompress) {
              self.fileToBase64(fileAfterCompress);
            },
            error(e) {
              console.log(e.message);
            },
          });

          this.errorUploadPhoto = false;
          this.messageErrorUploadPhoto = '';
        }

        if (!(file.size < 5242880)) {
          this.errorUploadPhoto = true;
          this.messageErrorUploadPhoto = 'Ukuran maksimum 5MB';
        }

        if (!/png|jpg|jpeg/.test(file.type)) {
          this.errorUploadPhoto = true;
          this.messageErrorUploadPhoto = 'File harus png, jpg, jpeg.';
        }

        if (isReachTotalMaxFile) {
          this.errorUploadPhoto = true;
          this.messageErrorUploadPhoto = 'File yang akan anda upload telah mencapai batas maksimal 6';
        }
      }
    },
  },
};
</script>
